const religiousCommitment = [
  { label: "Seriously practising", value: "Seriously practising" },
  { label: "Moderately practising", value: "Moderately practising" },
  { label: "Not practising", value: "Not practising" },
];
export default religiousCommitment;
